var BlockView = require('views/block/base-block-view');

var PortfolioService = require('services/portfolio-service');
var LocaleService = require('services/locale-service');
const AhoyService = require('services/ahoy-service');

var ChecklistView = BlockView.extend({
  initialize: function (options) {
    BlockView.prototype.initialize.apply(this, arguments);
    this.bind();

    var self = this;
    if (this.model.get('tab_order')) {
      this.model.set('tab_order', true);
    } else {
      this.model.set('tab_order', false);
    }
    this.delegate('focus', '#other-field-textbox', function (e) {
      this.$el.find('#other-field-checkbox').prop('checked', true);
      AhoyService.track('checklist', { action: 'checked other-field-checkbox' });
    });
    this.delegate('blur', '#other-field-textbox', function (e) {
      if (this.$el.find("input[type='text']").val() === '') {
        this.$el.find('#other-field-checkbox').prop('checked', false);
        AhoyService.track('checklist', { action: 'unchecked other-field-checkbox' });
      }
    });

    this.delegate('change', '#other-field-checkbox', function (e) {
      if (!$(e.currentTarget).prop('checked')) {
        var textBox = this.$el.find("input[type='text']");
        textBox.val('');
        self.saveOtherField(textBox.val());
        AhoyService.track('checklist', {
          action: 'changed other-field-checkbox',
          value: textBox.val(),
          class: $(e.currentTarget).attr('class'),
        });
      }
    });

    this.delegate('change', '#other-field-textbox', function (e) {
      var textBoxValue = $(e.currentTarget).val();
      if (textBoxValue !== undefined) {
        self.saveOtherField(textBoxValue);
        AhoyService.track('checklist', {
          action: 'changed other-field-textbox',
          value: textBoxValue,
          class: $(e.currentTarget).attr('class'),
        });
      }
    });
  },
  saveOtherField: function (value) {
    PortfolioService.addOtherChecklistItem(this.model.get('checklist_key'), value);

    var otherItem = this.model.get('other_item') || {}; //push to the model as well, so the view can render it
    otherItem.text = value;
    this.model.set('other_item', otherItem);

    //Setup and rerender the view so the new item in otherItem shows up
    this.bind();
    this.reRender();
  },
  bind: function () {
    var self = this;
    var checklist = PortfolioService.getChecklist(this.model.get('checklist_key'));
    var items = checklist.items;

    this.model.set('other_item', checklist.other_item || this.model.get('other_item') || {});

    if (this.model.get('items_where')) {
      items = _.filter(items, this.model.get('items_where'));
    }

    //if include_in_list is set, the item should be included in the checklist
    var otherField = this.model.get('other_field');
    var otherItem = this.model.get('other_item');
    if (otherField !== undefined && otherField.include_in_list && otherItem.text) {
      items.push(this.model.get('other_item'));
    }

    this.model.set('checklist_items', items);

    if (items.length < 1) {
      this.model.set('list_empty', true);
    }

    _.each(this.model.get('checklist_items'), function (item) {
      if (item.auto_add) {
        item.checked = true;
        PortfolioService.setChecklistItemValue(self.model.get('checklist_key'), item.key, true);
      }
    });
  },
  play: function () {
    var self = this;
    this.delegate('click', '[data-checklist]', function (e) {
      var $target = $(e.currentTarget);
      var item = $target.attr('data-checklist');
      AhoyService.track('checklist', {
        action: 'data-checklist:' + $target.attr('data-action'),
        item: item,
        class: $(e.currentTarget).attr('class'),
      });
      if ($target.attr('data-action') === 'delete') {
        PortfolioService.deleteCustomChecklistItem(self.model.get('checklist_key'), item);
        self.bind();
        self.reRender();
      } else if (item === 'add-custom') {
        e.preventDefault();
        if (String($('#custom-checklist').val()).trim() === '') {
          self.showMessage('.error');
        } else {
          PortfolioService.addCustomChecklistItem(self.model.get('checklist_key'), $('#custom-checklist').val());
          this.bind();
          self.reRender();
          self.showMessage('.success');
        }
      } else {
        PortfolioService.setChecklistItemValue(
          self.model.get('checklist_key'),
          $target.attr('data-checklist'),
          e.currentTarget.checked
        );
        self.checkComplete();
      }
    });

    this.delegate('change', '.checklist input[type="checkbox"]', function (e) {
      $('.checklist-item input[type="checkbox"]').each(function () {
        var li = $(this).closest('li.checklist-item');
        if ($(this).is(':checked')) {
          li.attr('data-checked', '');
          AhoyService.track('checklist', { action: 'checkbox', status: 'checked', class: li.attr('class') });
        } else {
          li.removeAttr('data-checked');
          AhoyService.track('checklist', { action: 'checkbox', status: 'unchecked', class: li.attr('class') });
        }
      });
    });
    this.checkComplete();
  },
  showMessage: function (selector) {
    var self = this;
    this.$(selector)
      .fadeIn()
      .focus()
      .delay(3000)
      .fadeOut('slow', function () {
        if (document.activeElement === this) {
          self.$('#custom-checklist').focus();
        }
      });
  },
  checkComplete: function () {
    if (this.model.get('items_required')) {
      var checkedCount = _.filter(this.model.get('checklist_items'), { checked: true }).length;
      if (checkedCount >= this.model.get('items_required')) {
        AhoyService.track('checklist', {
          action: 'completed',
          checkeditems: _.filter(this.model.get('checklist_items'), { checked: true }),
        });
        this.readyToGo();
      }
    } else {
      this.readyToGo();
    }
  },
  hideErrorMessage: function () {
    $('.error').fadeOut('slow');
  },
  showErrorMessage: function () {
    var self = this;
    $('.error').fadeIn();
    $('#custom-checklist').focus(function () {
      self.hideErrorMessage();
    });
  },
});

module.exports = ChecklistView;
